import { forwardRef } from 'react'
import type { ReactNode } from 'react'
import { Chip } from '@bosch/react-frok'
import type { ChipProps } from '@bosch/react-frok'

export type RichChipProps = Omit<ChipProps, 'label'> & {
    label: ReactNode
}

// FROK types `label` as string, but renders it as a React node: this is the typed way to pass an icon and a text.
// (A module declaration cannot do it: an interface property cannot be redeclared with another type.)
const RichChip = forwardRef<HTMLDivElement, RichChipProps>(({ label, ...props }, ref) => (
    <Chip {...props} ref={ref} label={label as string} />
))

RichChip.displayName = 'RichChip'

export default RichChip
